"use client";
import { Flex } from "antd";
import React, { useEffect, useRef, useState } from "react";
import useMobileDetect from "@/hooks/useMobileDetect";
import "./index.css";

type ViewportTrackerProps = {
  children: string | React.ReactNode;
};

export const ViewportTracker: React.FC<ViewportTrackerProps> = ({
  children,
  ...props
}) => {
  const isMobile = useMobileDetect();
  const cartARef = useRef(null);
  const [showView, setShowView] = useState(false);

  useEffect(() => {
    if (!cartARef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return; // 防止 entry 为 undefined
        const isAVisible = entry.intersectionRatio > 0;
        console.log(isAVisible, "show view port");
        const parentDiv = document.querySelector(".widget-visible");
        if (parentDiv) {
          // 获取父容器下的第一个iframe
          const targetIframe = parentDiv.querySelector("iframe");
          if (targetIframe) {
            targetIframe.style.transition = "bottom 0.3s ease-in-out";
            targetIframe.style.bottom = isAVisible ? "20px" : "100px";
          }
        }
        setShowView(!isAVisible);
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px 0px -1px 0px", // 底部100px视为特殊区域
      },
    );

    if (cartARef.current) {
      observer.observe(cartARef.current);
    }

    return () => {
      if (cartARef.current) {
        observer.unobserve(cartARef.current);
      }
    };
  }, []);

  return (
    <div>
      <div ref={cartARef} className="w-100% h-1 bg-transparent"></div>
      <div
        className={`${showView ? "transition-effect-show" : "transition-effect-hide"} fixed bottom-0 left-0 right-0 top-auto z-[999] bg-bravve-bg-100`}
      >
        <Flex
          align="center"
          gap={16}
          className={"bg-bravve-bg-100 p-12 pb-18 pt-18"}
        >
          {isMobile && children && children}
        </Flex>
      </div>
    </div>
  );
};
